export default __webpack_public_path__ + "static/media/angpao.31f56606.webp";